export default {
  title: 'Website Spesifikasi Lengkap dan Review Laptop No. 1 di Indonesia',
  description: 'Sebuah situs web yang mengulas tentang produk terutama Laptop secara lengkap dan mendalam. Anda bisa menemukan laptop pilihan sesuai dengan spesifikasi yang anda pilih.',
};
